import script from "./TeamMembersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMembersModal.vue?vue&type=script&setup=true&lang=js"

import "./TeamMembersModal.vue?vue&type=style&index=0&id=2a6b0dee&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6b0dee"]])

export default __exports__